import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import SanitizedText from "shared/components/SanitizedText";
import UserThumb from "shared/components/UserThumb";
import UserInfo from "shared/components/UserInfo";
import UserMatchInfo from "shared/components/UserMatchInfo";

import "./UserRow.scss";

const UserRow = ({
	className,
	last_contacts: lastContacts,
	likes,
	online,
	percentages,
	thumbs,
	shouldDisableIndicators,
	shouldDisableAnimationLikes,
	shouldDisablePopover,
	unread,
	userinfo,
	username,
	inactive,
	displayType,
	showInactive,
	firstMessage,
}) => {
	// Don't display if inactive.
	if ((!showInactive && inactive) || !username) {
		return null;
	}

	// Is this a card-type display?
	const displayAsCard = [
		UserRow.displayTypes.Card,
		UserRow.displayTypes.LargeCard,
		UserRow.displayTypes.SmallCard,
		UserRow.displayTypes.ResponsiveCard,
	].indexOf(displayType) > -1;

	// Show the thumb as a box if card mode, round otherwise.
	const thumbShape = displayAsCard
		? UserThumb.displayTypes.Box
		: UserThumb.displayTypes.Round;

	return (
		<div className={classnames(displayType, className)}>
			{displayAsCard && firstMessage &&
				<span
					title={unescape(firstMessage)}
					className={`${displayType}-first-message`}
				>
					<SanitizedText
						text={firstMessage}
						className={`${displayType}-first-message-content`}
					/>
				</span>
			}
			{unread && (
				<div className={`${displayType}-unread-indicator`} />
			)}
			<div
				className={`${displayType}-thumb`}
				data-username={username}
				data-profile-popover={!shouldDisablePopover || undefined}
			>
				<UserThumb
					username={userinfo.displayname}
					shouldDisableIndicators={shouldDisableIndicators}
					shouldDisableAnimationLikes={shouldDisableAnimationLikes}
					indicatorWidth={displayAsCard ? 6 : 3}
					thumbs={thumbs}
					last_contacts={lastContacts}
					likes={likes}
					size="225x225"
					shape={thumbShape}
				/>
			</div>
			<UserInfo
				className={`${displayType}-info`}
				name={userinfo.displayname}
				age={userinfo.age}
				location={userinfo.location}
				likes={likes}
				online={online}
				center={displayAsCard}
			/>
			{percentages && (
				<UserMatchInfo
					className={`${displayType}-match-info`}
					percentages={percentages}
					likes={likes}
				/>
			)}
		</div>
	);
};

UserRow.displayTypes = {
	Row: "userrow",
	Card: "usercard",
	LargeCard: "userlargecard",
	SmallCard: "usersmallcard",
	SmallRow: "usersmallrow",
	SmallRowVerical: "usersmallrowvertical",
	ResponsiveCard: "usersresponsivecard",
};

UserRow.propTypes = {
	className: PropTypes.string,
	last_contacts: PropTypes.object.isRequired,
	likes: PropTypes.object,
	online: PropTypes.bool,
	percentages: PropTypes.object,
	thumbs: PropTypes.array,
	shouldDisableIndicators: PropTypes.bool,
	shouldDisableAnimationLikes: PropTypes.bool,
	shouldDisablePopover: PropTypes.bool,
	unread: PropTypes.bool,
	userinfo: PropTypes.shape({
		displayname: PropTypes.string,
		location: PropTypes.string,
		age: PropTypes.number,
	}).isRequired,
	username: PropTypes.string.isRequired,
	inactive: PropTypes.bool,
	showInactive: PropTypes.bool,
	displayType: PropTypes.oneOf(Object.values(UserRow.displayTypes)),
	firstMessage: PropTypes.string,
};

UserRow.defaultProps = {
	className: "",
	likes: null,
	percentages: null,
	online: false,
	thumbs: [],
	shouldDisableIndicators: false,
	shouldDisableAnimationLikes: false,
	shouldDisablePopover: false,
	unread: false,
	inactive: false,
	showInactive: false,
	displayType: UserRow.displayTypes.Row,
	firstMessage: null,
};

export default UserRow;



// WEBPACK FOOTER //
// ./src/shared/components/UserRow.jsx